<!--
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="add-detail-content">
    <jw-drawer :width="data.drawerWidth" :visible="data.visible" @cancel="handleCancel" unmount-on-close :footer="false" :header="false" :drawer-style="{ backgroundColor: 'var(--color-fill-2)' }" class="add-order-details-drawer">
      <jw-card :bordered="false">
        <template #title>{{ $t('添加明细') }}</template>
        <template #extra>
          <jw-space>
            <jw-button @click="handleCancel">{{ $t('取消') }}</jw-button>
            <jw-button type="primary" @click="addSalesOrder">{{ $t('确定') }}</jw-button>
          </jw-space>
        </template>
        <jw-space direction="vertical" fill>
          <jw-row>
            <jw-col :span="12" class="jw-col-span">
              <div class="title-content">
                <p class="title">{{ $t('销售订单') }}</p>
                <jw-input-search :placeholder="$t('请输入销售订单编号')" class="input-search" @blur="orderSearch" @clear="orderSearch" @keyup.enter="orderSearch" @search="orderSearch" allow-clear v-model="data.orderCode"></jw-input-search>
              </div>
              <fh-table header-affixed-top row-key="id" v-model:selectedRowKeys="data.orderListID" @select-change="xlOrderSelect" :bordered="true" :pagination="null" :columns="data.orderColumns" :loading="data.loading" :data="data.orderData">
                <!-- 销售订单编号插槽--详情 -->
                <template #code="{ row }">
                  <span>{{ row.code || '-' }}</span>
                </template>
                <!-- 客户名称插槽--详情 -->
                <template #customerId="{ row }">
                  <span>{{ row.customer?.label || '-' }}</span>
                </template>
                <!-- 商机名称插槽--详情 -->
                <template #opportunityId="{ row }">
                  <span>{{ row.opportunity?.label || '-' }}</span>
                </template>
                <!--报价单名称插槽--详情 -->
                <template #priceSheetId="{ row }">
                  <span>{{ row.priceSheet?.label || '-' }}</span>
                </template>
                <!--销售合同插槽--详情 -->
                <template #contractId="{ row }">
                  <span>{{ row.contract?.label || '-' }}</span>
                </template>
                <!--生命状态 -->
                <template #status="{ row }">
                  <xl-status :status="row.statusVal" :statusOrigin="row.statusOrigin"></xl-status>
                </template>
                <!-- 产品  -->
                <template #productId="{ row }">
                  <span>{{ row?.productId || '-' }}</span>
                </template>
                <!-- 总数量  -->
                <template #totality="{ row }">
                  <span v-if="row?.totality == 0">0</span>
                  <span v-else-if="row?.totality">{{ row?.totality || '-' }}</span>
                </template>
                <!-- 账期  -->
                <template #billPeriod="{ row }">
                  <span v-if="row?.billPeriod || row?.billPeriod == 0">{{ row?.billPeriod + $t('天') }}</span>
                  <template v-else>-</template>
                </template>
                <!-- 飞书合同编号-->
                <template #fsContractId="{ row }">
                  <span v-if="row?.fieldList?.filter((v) => v.fieldKey === 'fs_contract_code')[0]?.fieldValue">{{ row?.fieldList?.filter((v) => v.fieldKey === 'fs_contract_code')[0]?.fieldValue }}</span>
                  <template v-else>-</template>
                </template>
                <!-- 合同金额 -->
                <template #amount="{ row }">
                  {{ tools.getPrice(row?.amount)?.toFixed(2) || '-' }}
                </template>
                <!-- 负责人插槽 -->
                <template #chargePerson="{ row }">
                  <xl-avatar v-if="row.chargePerson" :avatar="{ name: row?.chargePersonName || '', url: row?.chargePersonAvatar, id: row?.chargePerson }" :size="22" />
                  <template v-else>-</template>
                </template>
                <!-- 创建人插槽 -->
                <template #createUser="{ row }">
                  <xl-avatar v-if="row?.createUser" :avatar="{ name: row?.createUserName || '', url: row?.createUserAvatar, id: row?.createUser }" :size="22" />
                  <template v-else>-</template>
                </template>
                <!-- 最后更新人插槽 -->
                <template #updateUser="{ row }">
                  <xl-avatar v-if="row.updateUser" :avatar="{ name: row.updateUserName || '', url: row.updateUserAvatar, id: row.updateUser }" :size="22" />
                  <template v-else>-</template>
                </template>
              </fh-table>
            </jw-col>
            <jw-col :span="1"></jw-col>
            <jw-col :span="11">
              <div class="title-content">
                <p class="title">{{ $t('销售订单产品') }}</p>
                <jw-input-search :placeholder="$t('请输入订单产品编号')" class="input-search" @blur="orderProductSearch" @clear="orderProductSearch" @keyup.enter="orderProductSearch" @search="orderProductSearch" allow-clear v-model="data.orderProductCode"></jw-input-search>
              </div>
              <fh-table sticky-header row-key="id" :bordered="true" :pagination="null" :loading="data.productLoading" v-model:selectedKeys="data.orderProductListID" :row-selection="data.rowProductSelection" @select="xlProductSelect" ref="xlUserTable" :columns="data.orderProductColumns" :data="data.orderProductData">
                <!-- 产品名称 -->
                <template #productId="{ row }">
                  <span>{{ row.productName || '-' }}</span>
                </template>
                <!-- 时长单位-->
                <template #timeUnit="{ row }">
                  <span>{{ row.timeUnitLabel || '-' }}</span>
                </template>
                <!-- 规格单位 -->
                <template #specificationUnit="{ row }">
                  <span>{{ row.specificationUnitLabel || '-' }}</span>
                </template>
                <!-- 客户折扣 -->
                <!-- <template #customerDiscount="{ row }">
                  {{ row }}
                  <span v-if="row?.customerDiscount">{{ row?.customerDiscount + '%' }}</span>
                  <span v-else>-</span>
                </template> -->
                <!-- 创建人-->
                <template #createUser="{ row }">
                  <xl-avatar v-if="row.createUser" :avatar="{ name: row.createUser?.userName || '', url: row.createUser?.avatar, id: row.createUser?.userId }" :size="22" />
                  <template v-else>-</template>
                </template>
                <!-- 更新人 -->
                <template #updateUser="{ row }">
                  <xl-avatar v-if="row.updateUser" :avatar="{ name: row.updateUser?.userName || '', url: row.updateUser?.avatar, id: row.updateUser?.userId }" :size="22" />
                  <template v-else>-</template>
                </template>
              </fh-table>
            </jw-col>
          </jw-row>
        </jw-space>
      </jw-card>
    </jw-drawer>
  </div>
</template>

<script setup>
import useViewFields from '@/hooks/view-fields';
import { salesOrderService } from '@/api/';
import { onMounted, reactive, inject } from 'vue';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
const { enableList, getViewFields, getFieldLabel } = useViewFields();
import { Message } from '@arco-design/web-vue';
const { t } = useI18n();
const emits = defineEmits(['cb']);
const data = reactive({
  visible: false,
  loading: false,
  productLoading: false,
  drawerWidth: '90%',
  orderCode: '',
  orderProductCode: '',
  orderType: 10, //销售订单
  orderProductType: 10, //销售订单--产品
  orderFieldList: [],
  orderProductFieldList: [],
  orderColumns: [],
  orderProductColumns: [],
  orderData: [],
  orderProductData: [],
  customerId: inject('globalParams')?.customerId,
  type: inject('globalParams')?.type, //30: 新增 40：修改
  orderListID: [],
  orderProductListID: [],
  newOrderListID: [],
  newOrderProductListID: [],
  rowSelection: {
    type: 'checkbox',
    showCheckedAll: false,
    onlyCurrent: true
  },
  rowProductSelection: {
    type: 'checkbox',
    showCheckedAll: false,
    onlyCurrent: true
  },
  tempPoductList: [],
  orderCodeList: []
});
//搜索销售订单
const orderSearch = () => {
  getOrderData();
};
// 销售订单产品
const orderProductSearch = () => {
  getOrderProductData();
};
// 销售订单--单选
const xlOrderSelect = (value) => {
  data.orderListID = value;
  console.log(value);
  getSelectOrderCodeList(data.orderListID, data.orderData);
  getOrderProductData();
};
//已选中的销售订单code
const getSelectOrderCodeList = (orderListID, orderData) => {
  data.orderCodeList = orderData?.filter((item) => orderListID?.map((id) => id === item.id)).map((key) => key.code);
};
//获取所选产品对应的订单code
const getOrderCode = (productList, productListIds) => {
  const selecListCode = productList.filter((item) => productListIds.includes(item.id)).map((key) => key.orderId?.label); //获取已选订单d的code
  data.orderListID = data.orderData.filter((item) => selecListCode.includes(item.code)).map((key) => key.id); //获取已选订单对应的id
};

//销售产品---单选
const xlProductSelect = (value) => {
  data.orderProductListID = value;
  console.log(value);
  if (value.length > 0) {
    getOrderCode(data.orderProductData, data.orderProductListID);
  } else {
    data.orderCodeList = [];
    data.orderListID = [];
  }
};
//
const openDialog = async () => {
  data.visible = true;
  data.orderCode = '';
  data.orderListID = [];
  data.orderData = [];
  data.orderProductData = [];
  data.orderProductListID = [];
  getOrderFields();
};
//获取销售订单字段
const getOrderFields = async () => {
  data.orderColumns = await getOrderColumns();
  data.orderProductColumns = await getOrderProductColumns();
  getOrderData();
};
const handleCancel = () => {
  data.visible = false;
};
const addSalesOrder = async () => {
  await getSelectProductList();
  emits('cb', data.tempPoductList);
  data.visible = false;
};

// 获取销售订单--字段
const getOrderColumns = async () => {
  data.loading = true;
  await getViewFields({ id: data.orderType, apiIndex: 0 });
  data.orderFieldList = enableList.value?.filter((el) => el.fieldType != 18);
  const list = [{ colKey: 'row-select', fixed: 'left', type: 'multiple' }];
  data.orderFieldList?.forEach((item) => {
    const k = item.fieldKey; //字段标识
    const render = (h, { row }) => {
      const record = JSON.parse(JSON.stringify(row));
      record.fieldList?.map((keys) => {
        record[keys.fieldKey] = keys.fieldValue;
        if ([2, 3, 4, 5, 10].indexOf(keys.fieldType) > -1) {
          record[keys.fieldKey] = getFieldLabel(keys.fieldValue, keys.fieldExt, keys.fieldType);
        }
      });
      const fieldValue = record[k];
      if (fieldValue || fieldValue === 0) {
        if (item.fieldType === 9) {
          if (fieldValue && fieldValue !== '{}') {
            return Object.values(JSON.parse(fieldValue))?.join('/');
          } else {
            return '-';
          }
        } else if (item.fieldType === 6) {
          if (fieldValue instanceof Array) {
            // console.log('查看人员头像303', fieldKey);
            return fieldValue?.map((v) => v.name)?.join(',');
          } else {
            return '-';
          }
        } else if ([2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
          // console.log(366, item?.fieldExtObj, fieldKey, item?.fieldExtObj[fieldKey]?.label);
          return getFieldLabel(fieldValue, item.fieldExt, item.fieldType);
        } else if (item.fieldType === 12) {
          return fieldValue?.label || '-';
        } else if (item.fieldType === 16) {
          return (fieldValue && tools.getPrice(fieldValue, item.fieldExt)) || '-';
        } else if (item.fieldType === 23) {
          return tools.getPercentage(fieldValue, item?.fieldExt) + '%' || '-';
        } else if (item.fieldType === 24) {
          //计算类型
          if (item.fieldExt && tools.isJSON(item.fieldExt)) {
            if (JSON.parse(item.fieldExt)?.type == 6 || JSON.parse(item.fieldExt)?.type == 16) {
              //6：汇总金额 16：金额
              return fieldValue ? tools.getPrice(fieldValue, item.fieldExt) : '-';
            } else if (JSON.parse(item.fieldExt)?.type == 23) {
              //百分比
              return fieldValue ? tools.getPercentage(fieldValue, item.fieldExt) + '%' : '-';
            } else if (JSON.parse(item.fieldExt)?.type == 5 || JSON.parse(item.fieldExt)?.type == 7) {
              // 数字
              return !isNaN(parseFloat(fieldValue)) ? tools.getNumberShow(fieldValue, item.fieldExt) : '-';
            } else {
              return fieldValue ?? '-';
            }
          }
        } else {
          if (item.fieldKey == 'billPeriod') {
            return fieldValue + t('天');
          } else {
            return fieldValue;
          }
        }
      } else {
        return '-';
      }
    };
    const colType = {
      title: item.fieldName,
      colKey: k,
      ellipsis: true,
      tooltip: true
    };
    if (item.type === 1) {
      colType.colType = t(t('基础字段'));
    }
    if (item.type === 2) {
      colType.dataIndex = `${k}Custom`;
    }
    let width = item.fieldName.length <= 5 ? 120 : item.fieldName.length * 30;
    if (k === 'code') {
      //销售订单编号
      list.push({ ...colType, fixed: 'left', slotName: 'code', width: 250 });
      // 客户/商机/报价单/销售合同/飞书合同
    } else if (k === 'customerId' || k === 'opportunityId' || k === 'priceSheetId' || k === 'contractId' || k === 'fsContractId') {
      list.push({ ...colType, slotName: k, width: 250 });
      // 生命状态
    } else if (k === 'status') {
      list.push({ ...colType, slotName: k, width: 100 });
    } else if (k === 'chargePerson' || k === 'createUser' || k === 'updateUser' || k === 'productId' || k === 'totality') {
      //负责人/创建人/更新人
      list.push({ ...colType, slotName: k, width: 130 });
    } else {
      // 创建时间/最后更新时间/停服日期/开服日期/客户回款日期/签约时间
      if (k === 'gmtUpdated' || k === 'gmtCreated' || k === 'endDate' || k === 'startDate' || k === 'customerPaymentDate' || k === 'signedTime') {
        width = 200;
      }
      list.push({ ...colType, width, cell: render });
    }
  });
  return list;
};
//获取销售订单-产品字段
const getOrderProductColumns = async () => {
  data.productLoading = true;
  await getViewFields({ id: 11, apiIndex: 1 });
  data.orderProductFieldList = enableList.value?.filter((el) => el.fieldType != 18);
  const list = [];
  data.orderProductFieldList?.forEach((item) => {
    const k = item.fieldKey; //字段标识
    // if (item.type && item.type !== 0) {
    const render = (h, { row }) => {
      // console.log('record------',record);
      const record = JSON.parse(JSON.stringify(row));
      record.fieldValues?.map((keys) => {
        if (keys.fieldKey == 'accountPeriod') {
          keys.fieldValue = keys?.fieldValue || keys?.fieldValue == 0 ? keys?.fieldValue + t('天') : '-';
        }
        record[keys.fieldKey] = keys.fieldValue;
      });
      const fieldValue = record[k];
      if (fieldValue || fieldValue === 0) {
        if (item.fieldType === 9) {
          if (fieldValue && fieldValue !== '{}') {
            return Object.values(JSON.parse(fieldValue))?.join('/');
          } else {
            return '-';
          }
        } else if (item.fieldType === 6) {
          if (fieldValue instanceof Array) {
            // console.log('查看人员头像303', fieldKey);
            return fieldValue?.map((v) => v.name)?.join(',');
          } else {
            return '-';
          }
        } else if ([2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
          // console.log(366, item?.fieldExtObj, fieldKey, item?.fieldExtObj[fieldKey]?.label);
          return getFieldLabel(fieldValue, item.fieldExt, item.fieldType);
        } else if (item.fieldType === 12) {
          return fieldValue?.label || '-';
        } else if (item.fieldType == 16) {
          //金额
          if (item.fieldExt) {
            return fieldValue && Number(fieldValue) ? tools.getPrice(fieldValue, item?.fieldExt) : '-';
          } else {
            return fieldValue && Number(fieldValue) ? tools.getPrice(fieldValue) : '-';
          }
        } else if (item.fieldType == 23) {
          // return fieldKey && Number(fieldKey) ? Number(fieldKey).toFixed(JSON.parse(item?.fieldExt)?.numberFormat) + '%' : '-';
          return tools.getPercentage(fieldValue, item?.fieldExt) + '%' || '-';
        } else if (item.fieldType == 24) {
          //计算类型
          if (item.fieldExt && tools.isJSON(item.fieldExt)) {
            if (JSON.parse(item.fieldExt)?.type == 6 || JSON.parse(item.fieldExt)?.type == 16) {
              //6：汇总金额 16：金额
              return fieldValue ? tools.getPrice(fieldValue, item.fieldExt) : '-';
            } else if (JSON.parse(item.fieldExt)?.type == 23) {
              //百分比
              return fieldValue ? tools.getPercentage(fieldValue, item.fieldExt) + '%' : '-';
            } else if (JSON.parse(item.fieldExt)?.type == 5 || JSON.parse(item.fieldExt)?.type == 7) {
              // 数字
              return !isNaN(parseFloat(fieldValue)) ? tools.getNumberShow(fieldValue, item.fieldExt) : '-';
            } else {
              return fieldValue ?? '-';
            }
          }
        } else {
          return fieldValue;
        }
      } else {
        return '-';
      }
    };
    const colType = {
      title: item.fieldName,
      colKey: k,
      ellipsis: true,
      tooltip: true
    };
    const width = item.fieldName.length <= 5 ? 120 : item.fieldName.length * 30;
    if (k === 'productId') {
      //产品名称
      list.push({ ...colType, fixed: 'left', width: 150, slotName: k });
      // || k === 'customerDiscount'
    } else if (k === 'timeUnit' || k === 'specificationUnit') {
      //时长单位，规格单位
      list.push({ ...colType, width, slotName: k });
    } else if (k === 'createUser' || k === 'updateUser') {
      //创建人，更新人
      list.push({ ...colType, width: 150, slotName: k });
    } else if (k === 'gmtCreated' || k === 'gmtUpdated') {
      //创建时间，更新时间
      list.push({ ...colType, width: 200, cell: render });
    } else {
      list.push({ ...colType, width, cell: render });
    }
    // }
  });
  data.productLoading = false;
  return list;
};
// 销售订单列表
const getOrderData = async () => {
  try {
    const res = await salesOrderService.getOrderList({ customerId: data.customerId, code: data.orderCode });
    data.loading = false;
    if (res.error && res.error?.msg) {
      Message.error(res.error?.msg || t('获取数据失败'));
      return;
    }
    data.orderData = res?.result || [];
    if (!data.orderData.length) {
      data.orderListID = [];
      data.orderProductData = [];
      data.orderProductListID = [];
      return;
    }
  } catch (e) {
    data.loading = false;
  }
};
//销售订单产品列表
const getOrderProductData = async () => {
  data.productLoading = true;

  try {
    const res = await salesOrderService.getProductByOrderId({ entityType: data.orderProductType, ids: data.orderListID, code: data.orderProductCode });
    data.productLoading = false;
    if (res.error && res.error?.msg) {
      Message.error(res.error?.msg || t('获取数据失败'));
      return;
    }
    data.orderProductData = res?.result || [];
    data.orderProductListID = data.orderProductData?.filter((item) => data.orderCodeList?.map((code) => code === item.orderId?.label)).map((key) => key.id); //获取已选订单对应的产品id
  } catch (e) {
    data.productLoading = false;
  }
};
onMounted(() => {
  //   getOrderColumns();
});
const getSelectProductList = () => {
  data.tempPoductList = [];
  data.orderProductData.forEach((item) => {
    data.orderProductListID?.forEach((list) => {
      if (item.id == list) {
        data.tempPoductList.push(item);
      }
    });
  });
};
defineExpose({ openDialog });
</script>
<style scoped lang="less">
@import './add-order-detail.less';
</style>
